<app-card class="page-container">
  <app-card-header>
    <app-card-title class="flex gap-md flex-column">
      @if (!loading() && form()) {
        <div class="submit-header flex gap-md flex-wrap flex-align-center flex-justify-end">
          <app-checkpoint-form-header
            class="mr-auto"
            [checkpointName]="checkPoint()?.name ?? ''"
            [formName]="form()!.name"
            [serialNumber]="$safeNavigationMigration(instance()?.serial_number)"
            data-testid="checkPoint-info"
          />
          <ng-container *ngTemplateOutlet="formActions" />
        </div>
      }
      @if (loading()) {
        <span>{{ 'submission.form.loading' | translate }}</span>
      }
    </app-card-title>
  </app-card-header>

  <app-card-content>
    <!-- Loading State -->
    @if (loading()) {
      <div class="center-content">
        <app-spinner />
      </div>
    }

    <!-- Error State -->
    @if (error() && !loading()) {
      <div class="error-message" data-testid="error-message">
        <app-icon name="alert-circle" />
        {{ error() }}
      </div>
    }

    <!-- Form -->
    @if (!loading() && !error()) {
      <div class="form-container">
        <!-- Dynamic Form -->
        <form
          class="flex-column scrollable"
          [formGroup]="formlyGroup"
          (ngSubmit)="onSubmit()"
          data-testid="checkpoint-form"
        >
          @if (fields.length === 0) {
            <div class="no-form-message">
              <p>{{ 'submission.form.noCustomFields' | translate }}</p>
            </div>
          } @else {
            <formly-form
              class="flex-grow"
              [attr.data-columns]="formColumns()"
              [form]="formlyGroup"
              [fields]="fields"
              [model]="model"
              [options]="formlyOptions"
              (modelChange)="onModelChange($event)"
            ></formly-form>
          }
          <!-- Validation summary banner - shown near submit buttons once user has touched an invalid field -->
          @if (validationMessage) {
            <div class="validation-message" data-testid="validation-message">
              <app-icon name="alert-circle" [size]="14" class="validation-message__icon" />
              <span>{{ validationMessage }}</span>
            </div>
          }
          <!-- Form Actions -->
          <div class="form-actions">
            <ng-container *ngTemplateOutlet="formActions" />
          </div>
        </form>
      </div>
    }
  </app-card-content>

  <ng-template #formActions>
    <app-button
      type="button"
      variant="outlined"
      (click)="cancel()"
      [disabled]="saving()"
      data-testid="cancel-button"
    >
      <app-icon name="x" />
      {{ 'submission.form.cancel' | translate }}
    </app-button>
    <app-button
      type="button"
      variant="filled"
      (click)="onSubmit()"
      [disabled]="saving() || formlyGroup.invalid"
      data-testid="submit-scan-button"
    >
      @if (!saving()) {
        <app-icon name="qr-code" />
      }
      {{ 'submission.form.saveSubmission' | translate }}
    </app-button>
  </ng-template>
</app-card>
